import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import Button from '../../../UniformComponents/Button'
import Modal from '../../../UniformComponents/Modal'
import { trackBuilderQuestionMenuAction } from '../../../utils/MixpanelManager'

@observer
export default class QuestionDisable extends Component {
    constructor(props) {
        super(props)
    }

    close = (e) => {
        e.preventDefault()
        const { store } = this.props
        store.questionDisableConfirm = false
    }

    disableQuestion = (e) => {
        e.preventDefault()
        const { store } = this.props
        const { question } = store.questionToDisable
        trackBuilderQuestionMenuAction(store, { action: 'toggle hide question', value: Boolean(!question.isHidden) })

        question.isHidden = !question.isHidden

        store.questionDisableConfirm = false
    }

    thisQuestionHasSkipLogic = () => {
        const { store } = this.props
        const { question } = store.questionToDisable
        return question.hasSkipLogic(store)
    }

    hasAppliedSkipLogicToOtherQuestions = () => {
        const { store, store: { survey } } = this.props
        const { question: { id } } = store.questionToDisable
        return survey.skipLogic.some((sl) => sl.refersToQuestion(sl, id))
    }

    decideMessage = (store) => {
        const {
            question,
            question: {
                isHidden: questionIsHidden,
            },
        } = store.questionToDisable
        const { hasPrepopulatedData } = question
        const hasSkipLogicOrHasAppliedSkipLogic = this.hasAppliedSkipLogicToOtherQuestions()
            || this.thisQuestionHasSkipLogic()

        if (hasSkipLogicOrHasAppliedSkipLogic && !hasPrepopulatedData) {
            return i18n.t('conf_q_disable_skiplogic_present')
        } if (questionIsHidden) {
            return i18n.t('conf_q_show')
        } if (!questionIsHidden) {
            return i18n.t('conf_q_disable')
        }
    }

    modalText = () => {
        const { store } = this.props
        const disableButtonClicked = store.questionToDisable

        if (disableButtonClicked) {
            return this.decideMessage(store)
        }
        return ''
    }

    render() {
        const { store } = this.props
        const isQuestionHidden = store.questionToDisable
            ? store.questionToDisable.question.isHidden
            : undefined
        return (
            <Modal
                show={store.questionDisableConfirm}
                onClose={this.close}
            >
                <div id="question-disable-modal">
                    <div className="uc-modal__header">
                        <h2>{i18n.t('gen_confirm_popup_title')}</h2>
                        <p className="uc-modal__desc">
                            {store.questionDisableConfirm && this.modalText()}
                        </p>
                    </div>
                    <div className="uc-modal__button-panel">
                        <Button
                            onClick={this.disableQuestion}
                            cssClass={isQuestionHidden ? 'primary' : 'error'}
                            label={i18n.t('gen_yes')}
                        />
                        <Button
                            onClick={this.close}
                            cssClass="tertiary"
                            label={i18n.t('gen_no')}
                        />
                    </div>
                </div>
            </Modal>
        )
    }
}
